import React from "react";
import { Link } from "react-router-dom";
import {
    Box,
    Card,
    CardActionArea,
    CardContent,
    CardHeader,
    Tooltip,
    Typography,
} from "@mui/material";

import JPAvatar from "../JPAvatar";
import DoughnutChart from "../Charts/DoughnutChart";
import RenderDate from "../../../Common/Date/RenderDate";
import { v4 as uuidv4 } from "uuid";

const JobPlanCard = ({ jobPlan, theme }) => {
    const title = jobPlan.title || jobPlan.resourceType;
    const activities = jobPlan.activities;
    const activityCount =
        activities && activities.length ? activities.length : 0;
    let contractedActivityCategories = [];

    // loop through all activities
    activities.forEach((activity) => {
        let durationAveragePW = 0;
        let annualOccurrences =
            activity["annualOccurrences"] && activity["annualOccurrences"] > 0
                ? activity["annualOccurrences"]
                : 1;

        if (activity["scheduled"]) {
            if (activity["scheduled"]["dayOfWeek"]) {
                annualOccurrences = jobPlan.workingWeeks;
                durationAveragePW =
                    (activity["durationNormal"] + activity["durationPremium"]) *
                    (annualOccurrences / jobPlan.workingWeeks);
            }
        }

        // if missing from the returned data
        if (!activity["type"]) {
            activity["type"] = {
                name: "Programmed Activity",
                code: "PA",
                contracted: true,
            };
        }

        // if missing from the returned data
        if (typeof activity["category"] === "string") {
            activity["category"] = {
                id: uuidv4(),
                code: activity["categoryType"] || "X",
                name: activity["category"],
            };
        }

        if (activity["type"]["contracted"]) {
            if (contractedActivityCategories[activity["category"]["name"]]) {
                contractedActivityCategories[activity["category"]["name"]] +=
                    durationAveragePW;
            } else {
                contractedActivityCategories[activity["category"]["name"]] =
                    durationAveragePW;
            }
        }
    });
    /// end loop

    // prepare dataset for activity categories
    let activityCategoriesData = [];
    for (const prop in contractedActivityCategories) {
        activityCategoriesData.push(contractedActivityCategories[prop]);
    }
    const dataSetCategories = {
        labels: Object.keys(contractedActivityCategories),
        values: activityCategoriesData,
    };

    return (
        <Card className="card">
            <CardActionArea
                component={Link}
                to={`/jp/jobplans/${Number(jobPlan.id) || ""}`}
                centerRipple={true}
            >
                <CardHeader
                    disableTypography={true}
                    avatar={
                        <Tooltip title="View this Job plan" arrow>
                            <JPAvatar type="jobplan" />
                        </Tooltip>
                    }
                    title={
                        <Typography
                            component="h2"
                            className="card-header-title"
                        >
                            {title}
                        </Typography>
                    }
                    subheader={
                        <Typography
                            component="span"
                            className="card-header-subtitle"
                        >
                            <RenderDate date={jobPlan.effectiveDate} />
                        </Typography>
                    }
                />
            </CardActionArea>
            <CardContent>
                {activityCount > 0 ? (
                    <Box className="doughnut">
                        <DoughnutChart
                            labels={dataSetCategories.labels}
                            values={dataSetCategories.values}
                            label={""}
                        />
                    </Box>
                ) : (
                    <Box className="card-content">
                        This job plan currently contains 0 activities.
                    </Box>
                )}
            </CardContent>
            {activityCount > 0 && (
                <CardContent>
                    <Box className="card-content">
                        <Typography
                            variant="body2"
                            className="text"
                            sx={{ textAlign: "right" }}
                        >
                            {activityCount} activities{" "}
                        </Typography>
                    </Box>
                </CardContent>
            )}
        </Card>
    );
};

export default JobPlanCard;
